/* eslint-disable quotes, quote-props, comma-dangle  */
import type { TranslationProps } from './types';

export const translations = {
  "cancel_button_label": [
    {
      "type": 0,
      "value": "取消"
    }
  ],
  "warning_body_list_item_one": [
    {
      "type": 0,
      "value": "您已取得存取顧客資料的業務理由"
    }
  ],
  "warning_body_list_item_two": [
    {
      "type": 0,
      "value": "系統將會記錄和追蹤您的下載活動，以確保符合安全合規規範"
    }
  ],
  "warning_footer": [
    {
      "type": 0,
      "value": "您要繼續嗎？"
    }
  ],
  "warning_header": [
    {
      "type": 0,
      "value": "下載即表示您確認："
    }
  ]
};

function TranslationProviderComponent({ children }: TranslationProps) {
  return children(translations);
}

export default Object.assign(TranslationProviderComponent, { translations });
